import { render, staticRenderFns } from "./Kink.vue?vue&type=template&id=745cc732&scoped=true"
import script from "./Kink.vue?vue&type=script&lang=ts"
export * from "./Kink.vue?vue&type=script&lang=ts"
import style0 from "./Kink.vue?vue&type=style&index=0&id=745cc732&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745cc732",
  null
  
)

export default component.exports